import React from 'react';
import { FieldValidationErrorsType, showErrorFlush } from '../../../common/form/FrekulForm';
import MusicAlbumEditForm4View from './MusicAlbumEditForm4View';
import MusicAlbumEditForm4DistributionPopup1 from './MusicAlbumEditForm4DistributionPopup1';
import MusicAlbumEditForm4DistributionPopup2 from './MusicAlbumEditForm4DistributionPopup2';
import MusicAlbumEditForm4DistributionPopup3 from './MusicAlbumEditForm4DistributionPopup3';
import MusicAlbumEditForm4DistributionPopup4 from './MusicAlbumEditForm4DistributionPopup4';
import { MusicDistributionClientContext } from '../../context/MusicDistributionClientContext';
import { MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicComposerEntity, MusicEntity, MusicLyricWriterEntity } from '../../types/MusicEntityTypes';

/**
 * 確認画面
 */
export default function MusicAlbumEditForm4({
  musicAlbum,
} : {
  musicAlbum: MusicAlbumEntity & {
    music_album_tracks: (MusicAlbumTrackEntity & {
      music: MusicEntity & {
        music_lyric_writers: MusicLyricWriterEntity[],
        music_composers: MusicComposerEntity[],
      }
    })[],
  },
}) {
  const [popup, setPopup] = React.useState<'popup1'|'popup2'|'popup3'|'popup4'|null>(null);
  const [ajax, setAjax] = React.useState<'publish'|null>(null);
  const [errors, setErrors] = React.useState<{ [key: string]: FieldValidationErrorsType }>({});
  const { publishMusicAlbum } = React.useContext(MusicDistributionClientContext);

  React.useEffect(() => {
    if (ajax === 'publish') {
      publishMusicAlbum(musicAlbum.id).then((responseData) => {
        setAjax(null);
        setErrors(responseData.validationErrors as { [key: string]: FieldValidationErrorsType });
        if (responseData.result) {
          setPopup('popup4');
        } else {
          showErrorFlush(responseData.msg);
          setPopup(null);
        }
      });
    }
  }, [ajax]);

  return (
    <>
      <MusicAlbumEditForm4View
        getErrors={(name) => errors?.[name] || []}
        musicAlbum={musicAlbum}
        onBack={() => {
          document.location.href = `/music_albums/edit_tracks/${musicAlbum.id}`;
        }}
        onNext={() => {
          setPopup('popup1');
        }}
        onStep={(callback) => {
          callback(musicAlbum.id);
        }}
      />
      {popup === 'popup1' && (
        <MusicAlbumEditForm4DistributionPopup1
          onNext={() => setPopup('popup2')}
          onClose={() => setPopup(null)}
        />
      )}
      {popup === 'popup2' && (
        <MusicAlbumEditForm4DistributionPopup2
          onNext={() => setPopup('popup3')}
          onClose={() => setPopup(null)}
        />
      )}
      {popup === 'popup3' && (
        <MusicAlbumEditForm4DistributionPopup3
          onBack={() => setPopup(null)}
          onNext={() => setAjax('publish')}
          onClose={() => setPopup(null)}
        />
      )}
      {popup === 'popup4' && (
        <MusicAlbumEditForm4DistributionPopup4
          musicAlbum={musicAlbum}
          onClose={() => {
            document.location.href = '/music_albums/';
          }}
          onGoToHome={() => {
            document.location.href = '/';
          }}
          onGoToIndex={() => {
            document.location.href = '/music_albums/';
          }}
        />
      )}
    </>
  );
}
